var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CartaFeatureList, GeojsonConverter } from 'ng-carta';
var NotifyingCartaFeatureList = /** @class */ (function (_super) {
    __extends(NotifyingCartaFeatureList, _super);
    function NotifyingCartaFeatureList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pmDestination = undefined;
        _this.pmOrigin = undefined;
        return _this;
    }
    NotifyingCartaFeatureList.prototype.setPostMessageDestination = function (destination, origin) {
        this.pmDestination = destination;
        this.pmOrigin = origin;
    };
    NotifyingCartaFeatureList.prototype.sendGeoJson = function () {
        if (this.pmDestination === undefined) {
            return;
        }
        var features = this.getArray();
        var geoJson = GeojsonConverter.toGeojson(features);
        this.pmDestination.postMessage(JSON.stringify(geoJson), this.pmOrigin);
    };
    NotifyingCartaFeatureList.prototype.push = function (elem) {
        var value = _super.prototype.push.call(this, elem);
        elem.getGeometry().on('change', function () {
            // noinspection JSPotentiallyInvalidUsageOfClassThis
            this.sendGeoJson();
        }.bind(this));
        this.sendGeoJson();
        return value;
    };
    NotifyingCartaFeatureList.prototype.remove = function (elem) {
        var value = _super.prototype.remove.call(this, elem);
        this.sendGeoJson();
        return value;
    };
    return NotifyingCartaFeatureList;
}(CartaFeatureList));
export { NotifyingCartaFeatureList };
